
import React from 'react';
import { Container, Card, CardBody } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBalanceScale } from '@fortawesome/free-solid-svg-icons';
import footerBg from "./../../assets/footerbg.jpg";

const Nalsa = () => {
  return (
    <>
      <div style={{
        backgroundImage: `url(${footerBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        padding: '30px 0',
        color: 'white',
        margin: '2%',
        borderRadius: '10px'
      }}>
        <Container>
          <h3 className="fw-bold mb-0 text-center">
            <FontAwesomeIcon icon={faBalanceScale} className="me-2" />
            National Legal Services Authority
          </h3>
        </Container>
      </div>

      <Container className="py-5">
        <Card className="border-0" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)' }}>
          <div style={{
            background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
            padding: '25px',
            color: 'white'
          }}>
            <h4 className="fw-bold mb-0">
              <FontAwesomeIcon icon={faBalanceScale} className="me-2" />
              Veer Parivar Sahayata Yojana
            </h4>
          </div>
          <CardBody className="p-4">
            <div className="mb-4">
              <p style={{ color: '#495057', lineHeight: '1.7', fontSize: '1.05rem' }}>
                NALSA for ex-servicemen in Haryana is the Veer Parivar Sahayata Yojana, a Nationwide legal aid scheme by the National Legal Services Authority (NALSA).
              </p>
            </div>
            
            <div className="mb-0">
              <p style={{ color: '#495057', lineHeight: '1.7', fontSize: '1.05rem' }}>
                NALSA Provides free legal services, advice, and representations to serving / retired defence personnel, veterans, and their families for civil, criminal, property, pension, and welfare issues, ensuring access to justice through dedicated clinics opened at each District Welfare Office.
              </p>
            </div>
          </CardBody>
        </Card>
      </Container>
    </>
  );
}

export default Nalsa;
